import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/magic.ai/frontend/magicsquare/apps/launchpad/components/pages/HowItWorks/Page.tsx");
